class landingOfferProduct extends HTMLElement {
    constructor() {
        super();

        this.discountCode = this.dataset.discountCode;
        this.variantId = this.dataset.variantId;
        this.addToCartButton = this.querySelector('[data-buy-button]');
        this.popup = this.querySelector('.product-card__popup')

        if(!this.popup) return
        this.handlePopup()
    }

    handlePopup(){
        this.popup.addEventListener("click", (event) => {
            if(event.target === event.currentTarget || event.target.closest('[data-close]'))
                this.togglePopup(false)
        })
    }

    connectedCallback() {
        if (!this.addToCartButton) return;
        
        this.addToCartButton.classList.remove('loading');
        this.addToCartButton.addEventListener('click', () => this.handleAddToCartClick())
    }

    async handleAddToCartClick() {
        if(this.popup){
            this.togglePopup()
            return
        }

        this.addToCartButton.classList.add('loading');
        await this.clearCart()
        this.addToCart();
    }

    clearCart() {
        return fetch('/cart/clear.js')
    }

    async addToCart() {
        const bodyData = {
            'items': [{
                'id': Number(this.variantId),
                'quantity': 1,
            }]
        }

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', 
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
            }
        );

        if (response.ok) {
            window.location.href = this.discountCode ? `/checkout?discount=${this.discountCode}` : '/checkout'
        }
    }

    togglePopup(state = true){
        this.popup = this.popup || this.querySelector('.product-card__popup')
        if(!this.popup) return

        this.popup.toggleAttribute('open', state)
    }
}

customElements.define('landing-offer-product', landingOfferProduct)